import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTitle: {
    id: 'zoriRules.pageTitle',
    defaultMessage: 'Zori AI',
  },
  noData: {
    id: 'zoriRules.noData',
    defaultMessage: 'No rules found',
  },
  errorLoading: {
    id: 'zoriRules.errorLoading',
    defaultMessage: 'Error loading rules',
  },
  allTab: {
    id: 'zoriRules.allTab',
    defaultMessage: 'All Rules',
  },
  activeTab: {
    id: 'zoriRules.activeTab',
    defaultMessage: 'Active Rules',
  },
  inactiveTab: {
    id: 'zoriRules.inactiveTab',
    defaultMessage: 'Inactive Rules',
  },
  dryRunTab: {
    id: 'zoriRules.dryRunTab',
    defaultMessage: 'Dry Run Rules',
  },
  rulesTab: {
    id: 'zoriRules.rulesTab',
    defaultMessage: 'Rules',
  },
  ruleStatusFilterLabel: {
    id: 'zoriRules.ruleStatusFilterLabel',
    defaultMessage: 'Rule status',
  },
  knowledgeBaseTab: {
    id: 'zoriRules.knowledgeBaseTab',
    defaultMessage: 'Knowledge Base',
  },
  kbLoadingSyncState: {
    id: 'zoriRules.kbLoadingSyncState',
    defaultMessage: 'Loading sync state…',
  },
  kbClinicalPanelTitle: {
    id: 'zoriRules.kbClinicalPanelTitle',
    defaultMessage: 'Clinical knowledge',
  },
  kbClinicalInfoCallout: {
    id: 'zoriRules.kbClinicalInfoCallout',
    defaultMessage:
      'Files added here are available to member- and clinician-facing AI agents. Uploaded or removed files are synced to Zori within 30 minutes.',
  },
  kbInternalPanelTitle: {
    id: 'zoriRules.kbInternalPanelTitle',
    defaultMessage: 'Internal knowledge',
  },
  kbInternalInfoCallout: {
    id: 'zoriRules.kbInternalInfoCallout',
    defaultMessage:
      'Files added here are available to the employee (Slack) facing agent. Uploaded or removed files are synced to Zori within 30 minutes.',
  },
  dexConfigPanelTitle: {
    id: 'zoriRules.dexConfigPanelTitle',
    defaultMessage: 'Document extraction config',
  },
  dexConfigDocumentTypesTab: {
    id: 'zoriRules.dexConfigDocumentTypesTab',
    defaultMessage: 'Document Types',
  },
  pulseGuidanceTab: {
    id: 'zoriRules.pulseGuidanceTab',
    defaultMessage: 'Pulse Guidance',
  },
  autoScanTab: {
    id: 'zoriRules.autoScanTab',
    defaultMessage: 'Pulse Auto-Scan',
  },
  autoScanTitle: {
    id: 'zoriRules.autoScanTitle',
    defaultMessage: 'Pulse auto-scan configuration',
  },
  autoScanDescription: {
    id: 'zoriRules.autoScanDescription',
    defaultMessage:
      'Control which Zori Pulse sub-agents run for each membership tier and how often (in hours). Leave a cell blank to skip that sub-agent for the tier. Tiers not listed are not auto-scanned.',
  },
  autoScanSpreadWindowLabel: {
    id: 'zoriRules.autoScanSpreadWindowLabel',
    defaultMessage: 'Enrollment spread window (minutes)',
  },
  autoScanPrecedenceLabel: {
    id: 'zoriRules.autoScanPrecedenceLabel',
    defaultMessage: 'Tier precedence (comma-separated, richest first)',
  },
  autoScanChildAgentColumn: {
    id: 'zoriRules.autoScanChildAgentColumn',
    defaultMessage: 'Pulse sub-agent',
  },
  autoScanTierColumn: {
    id: 'zoriRules.autoScanTierColumn',
    defaultMessage: 'Membership tier',
  },
  autoScanTierPlaceholder: {
    id: 'zoriRules.autoScanTierPlaceholder',
    defaultMessage: 'e.g. apex',
  },
  autoScanAddTier: {
    id: 'zoriRules.autoScanAddTier',
    defaultMessage: 'Add tier',
  },
  autoScanRemoveTier: {
    id: 'zoriRules.autoScanRemoveTier',
    defaultMessage: 'Remove tier',
  },
  autoScanSave: {
    id: 'zoriRules.autoScanSave',
    defaultMessage: 'Save configuration',
  },
  autoScanReset: {
    id: 'zoriRules.autoScanReset',
    defaultMessage: 'Reset',
  },
  autoScanSaved: {
    id: 'zoriRules.autoScanSaved',
    defaultMessage: 'Auto-scan configuration saved',
  },
  autoScanLoadError: {
    id: 'zoriRules.autoScanLoadError',
    defaultMessage:
      'Unable to load the auto-scan configuration. Pulse auto-scan may be disabled for this account, or you may not have permission.',
  },
  autoScanInvalidSpreadWindow: {
    id: 'zoriRules.autoScanInvalidSpreadWindow',
    defaultMessage: 'Enter a valid, non-negative spread window in minutes.',
  },
  autoScanInvalidInterval: {
    id: 'zoriRules.autoScanInvalidInterval',
    defaultMessage: 'Interval hours must be positive whole numbers.',
  },
  autoScanDuplicateTier: {
    id: 'zoriRules.autoScanDuplicateTier',
    defaultMessage: 'Each membership tier can only be listed once.',
  },
  autoScanLastUpdated: {
    id: 'zoriRules.autoScanLastUpdated',
    defaultMessage: 'Last updated by {user} on {timestamp}',
  },
  pulseGuidanceListTitle: {
    id: 'zoriRules.pulseGuidanceListTitle',
    defaultMessage: 'Guidance versions',
  },
  pulseGuidanceCategoryLabel: {
    id: 'zoriRules.pulseGuidanceCategoryLabel',
    defaultMessage: 'Scan category',
  },
  pulseGuidanceCategoryAll: {
    id: 'zoriRules.pulseGuidanceCategoryAll',
    defaultMessage: 'All categories',
  },
  pulseGuidanceEmpty: {
    id: 'zoriRules.pulseGuidanceEmpty',
    defaultMessage: 'No guidance versions found',
  },
  pulseGuidanceSelectHint: {
    id: 'zoriRules.pulseGuidanceSelectHint',
    defaultMessage: 'Select a guidance version to review it',
  },
  pulseGuidanceNew: {
    id: 'zoriRules.pulseGuidanceNew',
    defaultMessage: 'New draft',
  },
  pulseGuidanceEdit: {
    id: 'zoriRules.pulseGuidanceEdit',
    defaultMessage: 'Edit draft',
  },
  pulseGuidanceApprove: {
    id: 'zoriRules.pulseGuidanceApprove',
    defaultMessage: 'Approve',
  },
  pulseGuidanceRevert: {
    id: 'zoriRules.pulseGuidanceRevert',
    defaultMessage: 'Revert',
  },
  pulseGuidanceSave: {
    id: 'zoriRules.pulseGuidanceSave',
    defaultMessage: 'Save',
  },
  pulseGuidanceCancel: {
    id: 'zoriRules.pulseGuidanceCancel',
    defaultMessage: 'Cancel',
  },
  pulseGuidanceSaved: {
    id: 'zoriRules.pulseGuidanceSaved',
    defaultMessage: 'Guidance saved',
  },
  pulseGuidanceApproved: {
    id: 'zoriRules.pulseGuidanceApproved',
    defaultMessage: 'Guidance approved',
  },
  pulseGuidanceReverted: {
    id: 'zoriRules.pulseGuidanceReverted',
    defaultMessage: 'Guidance reverted',
  },
  pulseGuidanceDelete: {
    id: 'zoriRules.pulseGuidanceDelete',
    defaultMessage: 'Delete draft',
  },
  pulseGuidanceDeleted: {
    id: 'zoriRules.pulseGuidanceDeleted',
    defaultMessage: 'Draft guidance deleted',
  },
  pulseGuidanceBundleLabel: {
    id: 'zoriRules.pulseGuidanceBundleLabel',
    defaultMessage: 'Guidance bundle (JSON)',
  },
  pulseGuidanceChangeReasonLabel: {
    id: 'zoriRules.pulseGuidanceChangeReasonLabel',
    defaultMessage: 'Change reason',
  },
  pulseGuidanceJsonInvalid: {
    id: 'zoriRules.pulseGuidanceJsonInvalid',
    defaultMessage: 'Guidance bundle is not valid JSON',
  },
  pulseGuidanceDiffTitle: {
    id: 'zoriRules.pulseGuidanceDiffTitle',
    defaultMessage: 'Changes vs prior version',
  },
  pulseGuidanceDiffNone: {
    id: 'zoriRules.pulseGuidanceDiffNone',
    defaultMessage: 'No prior version to compare against',
  },
  pulseGuidanceInstructionsTitle: {
    id: 'zoriRules.pulseGuidanceInstructionsTitle',
    defaultMessage: 'Instructions',
  },
  pulseGuidanceAvoidTitle: {
    id: 'zoriRules.pulseGuidanceAvoidTitle',
    defaultMessage: 'Avoid / down-rank',
  },
  pulseGuidanceAcceptableTitle: {
    id: 'zoriRules.pulseGuidanceAcceptableTitle',
    defaultMessage: 'Acceptable / useful patterns',
  },
  pulseGuidanceCorrectionsTitle: {
    id: 'zoriRules.pulseGuidanceCorrectionsTitle',
    defaultMessage: 'Field-level corrections',
  },
  pulseGuidanceEvidenceLabel: {
    id: 'zoriRules.pulseGuidanceEvidenceLabel',
    defaultMessage: 'Feedback evidence:',
  },
  pulseGuidanceNoPermission: {
    id: 'zoriRules.pulseGuidanceNoPermission',
    defaultMessage: 'You do not have permission to manage Pulse guidance.',
  },
  dexGuidanceReviewTab: {
    id: 'zoriRules.dexGuidanceReviewTab',
    defaultMessage: 'Extraction Guidance',
  },
  dexGuidanceReviewListTitle: {
    id: 'zoriRules.dexGuidanceReviewListTitle',
    defaultMessage: 'Guidance versions',
  },
  dexGuidanceReviewBundleLabel: {
    id: 'zoriRules.dexGuidanceReviewBundleLabel',
    defaultMessage: 'Guidance filter',
  },
  dexGuidanceReviewBundleAll: {
    id: 'zoriRules.dexGuidanceReviewBundleAll',
    defaultMessage: 'All guidance bundles',
  },
  dexGuidanceReviewStatusFilterDraft: {
    id: 'zoriRules.dexGuidanceReviewStatusFilterDraft',
    defaultMessage: 'Draft / needs review',
  },
  dexGuidanceReviewStatusFilterActive: {
    id: 'zoriRules.dexGuidanceReviewStatusFilterActive',
    defaultMessage: 'Active',
  },
  dexGuidanceReviewStatusFilterAll: {
    id: 'zoriRules.dexGuidanceReviewStatusFilterAll',
    defaultMessage: 'All',
  },
  dexGuidanceReviewEmpty: {
    id: 'zoriRules.dexGuidanceReviewEmpty',
    defaultMessage: 'No guidance versions found',
  },
  dexGuidanceReviewNoFilterMatches: {
    id: 'zoriRules.dexGuidanceReviewNoFilterMatches',
    defaultMessage: 'No guidance versions match the current filters',
  },
  dexGuidanceReviewSelectHint: {
    id: 'zoriRules.dexGuidanceReviewSelectHint',
    defaultMessage: 'Select a guidance version to review it',
  },
  dexGuidanceReviewNew: {
    id: 'zoriRules.dexGuidanceReviewNew',
    defaultMessage: 'New draft',
  },
  dexGuidanceReviewEdit: {
    id: 'zoriRules.dexGuidanceReviewEdit',
    defaultMessage: 'Edit draft',
  },
  dexGuidanceReviewEditAsNewDraft: {
    id: 'zoriRules.dexGuidanceReviewEditAsNewDraft',
    defaultMessage: 'Edit as new draft',
  },
  dexGuidanceReviewApprove: {
    id: 'zoriRules.dexGuidanceReviewApprove',
    defaultMessage: 'Approve',
  },
  dexGuidanceReviewRevert: {
    id: 'zoriRules.dexGuidanceReviewRevert',
    defaultMessage: 'Revert',
  },
  dexGuidanceReviewSave: {
    id: 'zoriRules.dexGuidanceReviewSave',
    defaultMessage: 'Save',
  },
  dexGuidanceReviewCancel: {
    id: 'zoriRules.dexGuidanceReviewCancel',
    defaultMessage: 'Cancel',
  },
  dexGuidanceReviewSaved: {
    id: 'zoriRules.dexGuidanceReviewSaved',
    defaultMessage: 'Guidance saved',
  },
  dexGuidanceReviewApproved: {
    id: 'zoriRules.dexGuidanceReviewApproved',
    defaultMessage: 'Guidance approved',
  },
  dexGuidanceReviewReverted: {
    id: 'zoriRules.dexGuidanceReviewReverted',
    defaultMessage: 'Guidance reverted',
  },
  dexGuidanceReviewBundleJsonLabel: {
    id: 'zoriRules.dexGuidanceReviewBundleJsonLabel',
    defaultMessage: 'Guidance bundle (JSON)',
  },
  dexGuidanceReviewChangeReasonLabel: {
    id: 'zoriRules.dexGuidanceReviewChangeReasonLabel',
    defaultMessage: 'Change reason',
  },
  dexGuidanceReviewJsonInvalid: {
    id: 'zoriRules.dexGuidanceReviewJsonInvalid',
    defaultMessage: 'Guidance bundle is not valid JSON',
  },
  dexGuidanceReviewDiffTitle: {
    id: 'zoriRules.dexGuidanceReviewDiffTitle',
    defaultMessage: 'Changes vs prior version',
  },
  dexGuidanceReviewDiffNone: {
    id: 'zoriRules.dexGuidanceReviewDiffNone',
    defaultMessage: 'No prior version to compare against',
  },
  dexGuidanceReviewFieldInstructionsTitle: {
    id: 'zoriRules.dexGuidanceReviewFieldInstructionsTitle',
    defaultMessage: 'Field instructions',
  },
  dexGuidanceReviewObservationRulesTitle: {
    id: 'zoriRules.dexGuidanceReviewObservationRulesTitle',
    defaultMessage: 'Observation rules',
  },
  dexGuidanceReviewMatchTermsLabel: {
    id: 'zoriRules.dexGuidanceReviewMatchTermsLabel',
    defaultMessage: 'Match terms:',
  },
  dexGuidanceReviewNoPermission: {
    id: 'zoriRules.dexGuidanceReviewNoPermission',
    defaultMessage: 'You do not have permission to manage Extraction guidance.',
  },
  guidanceSummarizeNow: {
    id: 'zoriRules.guidanceSummarizeNow',
    defaultMessage: 'Scan feedback',
  },
  guidanceSummarizeStarted: {
    id: 'zoriRules.guidanceSummarizeStarted',
    defaultMessage: 'Scanning feedback; new drafts will appear shortly.',
  },
  codingsTab: {
    id: 'zoriRules.codingsTab',
    defaultMessage: 'Codings',
  },
  codingsDescription: {
    id: 'zoriRules.codingsDescription',
    defaultMessage:
      'Review and approve the code mappings that turn vendor, extracted, uploaded, and questionnaire codes into results shown in PHC and the member app.',
  },
  codingsSearchAria: {
    id: 'zoriRules.codingsSearchAria',
    defaultMessage: 'Search codings',
  },
  codingsSearchPlaceholder: {
    id: 'zoriRules.codingsSearchPlaceholder',
    defaultMessage: 'Search by analyte name, code, or alias',
  },
  codingsObservationJumpLabel: {
    id: 'zoriRules.codingsObservationJumpLabel',
    defaultMessage: 'Find by observation code',
  },
  codingsUnmappedObservation: {
    id: 'zoriRules.codingsUnmappedObservation',
    defaultMessage:
      'No mapping found for {label}. Open the target mapping and add this observation code as an alias.',
  },
  codingsAliasPickerLabel: {
    id: 'zoriRules.codingsAliasPickerLabel',
    defaultMessage: 'Search observation codes to add as an alias',
  },
  codingsEnterAliasManually: {
    id: 'zoriRules.codingsEnterAliasManually',
    defaultMessage: 'Enter code manually',
  },
  codingsSuggestedAliases: {
    id: 'zoriRules.codingsSuggestedAliases',
    defaultMessage: 'Suggested aliases',
  },
  codingsSuggestedAliasesLoading: {
    id: 'zoriRules.codingsSuggestedAliasesLoading',
    defaultMessage: 'Looking for matching observation codes…',
  },
  codingsAddSuggestedAlias: {
    id: 'zoriRules.codingsAddSuggestedAlias',
    defaultMessage: 'Add',
  },
  codingsSearchButton: {
    id: 'zoriRules.codingsSearchButton',
    defaultMessage: 'Search',
  },
  codingsDisplayColumn: {
    id: 'zoriRules.codingsDisplayColumn',
    defaultMessage: 'Display',
  },
  codingsCodeColumn: {
    id: 'zoriRules.codingsCodeColumn',
    defaultMessage: 'Coding',
  },
  codingsMappingTypeColumn: {
    id: 'zoriRules.codingsMappingTypeColumn',
    defaultMessage: 'Mapping type',
  },
  codingsAliasesColumn: {
    id: 'zoriRules.codingsAliasesColumn',
    defaultMessage: 'Aliases',
  },
  codingsSourceColumn: {
    id: 'zoriRules.codingsSourceColumn',
    defaultMessage: 'Source',
  },
  codingsAiGenerated: {
    id: 'zoriRules.codingsAiGenerated',
    defaultMessage: 'AI generated',
  },
  codingsNoResults: {
    id: 'zoriRules.codingsNoResults',
    defaultMessage: 'No codings found',
  },
  codingsSearchPrompt: {
    id: 'zoriRules.codingsSearchPrompt',
    defaultMessage: 'Search for a coding or browse mappings',
  },
  codingsBrowseAll: {
    id: 'zoriRules.codingsBrowseAll',
    defaultMessage: 'Browse all',
  },
  codingsBrowseNeedsReview: {
    id: 'zoriRules.codingsBrowseNeedsReview',
    defaultMessage: 'Browse needs review',
  },
  codingsNew: {
    id: 'zoriRules.codingsNew',
    defaultMessage: 'New coding',
  },
  codingsSystem: {
    id: 'zoriRules.codingsSystem',
    defaultMessage: 'System',
  },
  codingsSystemFilterLabel: {
    id: 'zoriRules.codingsSystemFilterLabel',
    defaultMessage: 'Coding system',
  },
  codingsResultCategoryFilterLabel: {
    id: 'zoriRules.codingsResultCategoryFilterLabel',
    defaultMessage: 'Browse by category',
  },
  codingsResultCategoryFilterAll: {
    id: 'zoriRules.codingsResultCategoryFilterAll',
    defaultMessage: 'All result categories',
  },
  codingsSystemFilterLoinc: {
    id: 'zoriRules.codingsSystemFilterLoinc',
    defaultMessage: 'LOINC',
  },
  codingsSystemFilterExtractedData: {
    id: 'zoriRules.codingsSystemFilterExtractedData',
    defaultMessage: 'Extracted data',
  },
  codingsSystemFilterScreening: {
    id: 'zoriRules.codingsSystemFilterScreening',
    defaultMessage: 'Screening',
  },
  codingsSystemFilterTruage: {
    id: 'zoriRules.codingsSystemFilterTruage',
    defaultMessage: 'TruAge',
  },
  codingsSystemFilterDexa: {
    id: 'zoriRules.codingsSystemFilterDexa',
    defaultMessage: 'DEXA',
  },
  codingsSystemFilterCleerly: {
    id: 'zoriRules.codingsSystemFilterCleerly',
    defaultMessage: 'Cleerly',
  },
  codingsSystemFilterJona: {
    id: 'zoriRules.codingsSystemFilterJona',
    defaultMessage: 'JONA',
  },
  codingsSystemFilterAmra: {
    id: 'zoriRules.codingsSystemFilterAmra',
    defaultMessage: 'AMRA',
  },
  codingsSystemFilterViome: {
    id: 'zoriRules.codingsSystemFilterViome',
    defaultMessage: 'Viome',
  },
  codingsSystemFilterFunctional: {
    id: 'zoriRules.codingsSystemFilterFunctional',
    defaultMessage: 'Functional',
  },
  codingsSystemFilterAll: {
    id: 'zoriRules.codingsSystemFilterAll',
    defaultMessage: 'All systems',
  },
  codingsLoadMore: {
    id: 'zoriRules.codingsLoadMore',
    defaultMessage: 'Load more',
  },
  codingsViewDetails: {
    id: 'zoriRules.codingsViewDetails',
    defaultMessage: 'View coding details',
  },
  codingsReviewStatus: {
    id: 'zoriRules.codingsReviewStatus',
    defaultMessage: 'Review status',
  },
  codingsNeedsReview: {
    id: 'zoriRules.codingsNeedsReview',
    defaultMessage: 'Needs review',
  },
  codingsApproved: {
    id: 'zoriRules.codingsApproved',
    defaultMessage: 'Approved',
  },
  codingsAboutText: {
    id: 'zoriRules.codingsAboutText',
    defaultMessage: 'About',
  },
  codingsInterpretationTexts: {
    id: 'zoriRules.codingsInterpretationTexts',
    defaultMessage: 'Interpretation texts',
  },
  codingsReferenceRanges: {
    id: 'zoriRules.codingsReferenceRanges',
    defaultMessage: 'Reference ranges',
  },
  codingsSystems: {
    id: 'zoriRules.codingsSystems',
    defaultMessage: 'Result categories (systems)',
  },
  codingsSystemsHelp: {
    id: 'zoriRules.codingsSystemsHelp',
    defaultMessage:
      'Result categories power the Lab Results sections in PHC and the filter pills in the member app. Pick an existing category or create a new one — creating publishes it to both surfaces on save, with no app deploy. A coding can belong to more than one category. A code saved on a mapping but not in the registry stays hidden until you remap it to a registry category.',
  },
  codingsSystemsHelpHardcoded: {
    id: 'zoriRules.codingsSystemsHelpHardcoded',
    defaultMessage:
      "Systems power the top-level category filters shown in phc-ui and the quick-filter chips in the member app's results screen (e.g. Cardiovascular, Metabolic). A coding can belong to more than one category. phc-ui and the member app each hardcode the categories they display, so only the ones in this list reach members and clinicians — a category outside it is saved but never shown.",
  },
  codingsSubSystems: {
    id: 'zoriRules.codingsSubSystems',
    defaultMessage: 'Scrolling sections (sub-systems)',
  },
  codingsSubSystemsHelp: {
    id: 'zoriRules.codingsSubSystemsHelp',
    defaultMessage:
      "Sub-systems power the scrolling section headers on the member app's results screen (e.g. Coronary Artery, Lipid Panel). If none of a coding's sub-systems are recognized, the member app groups it under \"Blood Biomarkers\" by default — so a missing or typo'd sub-system can silently hide a result in the wrong section. Reuse an existing sub-system code where possible instead of creating a new one.",
  },
  codingsAddSystem: {
    id: 'zoriRules.codingsAddSystem',
    defaultMessage: 'Add category',
  },
  codingsRemoveSystem: {
    id: 'zoriRules.codingsRemoveSystem',
    defaultMessage: 'Remove category',
  },
  codingsAddSubSystem: {
    id: 'zoriRules.codingsAddSubSystem',
    defaultMessage: 'Add section',
  },
  codingsRemoveSubSystem: {
    id: 'zoriRules.codingsRemoveSubSystem',
    defaultMessage: 'Remove section',
  },
  codingsCategoryCode: {
    id: 'zoriRules.codingsCategoryCode',
    defaultMessage: 'Code',
  },
  codingsCategoryLabel: {
    id: 'zoriRules.codingsCategoryLabel',
    defaultMessage: 'Result category',
  },
  codingsCategoryPlaceholder: {
    id: 'zoriRules.codingsCategoryPlaceholder',
    defaultMessage: 'Select a result category',
  },
  codingsCategoryCreate: {
    id: 'zoriRules.codingsCategoryCreate',
    defaultMessage: 'Create new category',
  },
  codingsCategoryCreateHint: {
    id: 'zoriRules.codingsCategoryCreateHint',
    defaultMessage: 'Creates a Lab Results section and member-app pill on save',
  },
  codingsCategoryNewRequired: {
    id: 'zoriRules.codingsCategoryNewRequired',
    defaultMessage: 'New result categories need a display name and a code.',
  },
  codingsCategoryOptionBoth: {
    id: 'zoriRules.codingsCategoryOptionBoth',
    defaultMessage: '{code} - phc-ui and member app',
  },
  codingsCategoryOptionPhcUi: {
    id: 'zoriRules.codingsCategoryOptionPhcUi',
    defaultMessage: '{code} - phc-ui only',
  },
  codingsCategoryOptionMemberApp: {
    id: 'zoriRules.codingsCategoryOptionMemberApp',
    defaultMessage: '{code} - member app only',
  },
  codingsCategoryUnrecognizedOption: {
    id: 'zoriRules.codingsCategoryUnrecognizedOption',
    defaultMessage: 'Not in the result-category registry',
  },
  codingsCategoryUnrecognizedOptionHardcoded: {
    id: 'zoriRules.codingsCategoryUnrecognizedOptionHardcoded',
    defaultMessage: 'Unrecognized category',
  },
  codingsCategoryUnrecognized: {
    id: 'zoriRules.codingsCategoryUnrecognized',
    defaultMessage:
      'This category is not in the result-category registry, so it will not appear as a section. Pick an existing category or create a new one.',
  },
  codingsCategoryUnrecognizedHardcoded: {
    id: 'zoriRules.codingsCategoryUnrecognizedHardcoded',
    defaultMessage:
      'Neither phc-ui nor the member app displays this category, so it will not appear as a filter. Pick one from the list.',
  },
  codingsCategoryDisplay: {
    id: 'zoriRules.codingsCategoryDisplay',
    defaultMessage: 'Display',
  },
  codingsRangeSource: {
    id: 'zoriRules.codingsRangeSource',
    defaultMessage: 'Source',
  },
  codingsRangeStatus: {
    id: 'zoriRules.codingsRangeStatus',
    defaultMessage: 'Status',
  },
  codingsRangeLower: {
    id: 'zoriRules.codingsRangeLower',
    defaultMessage: 'Lower',
  },
  codingsRangeUpper: {
    id: 'zoriRules.codingsRangeUpper',
    defaultMessage: 'Upper',
  },
  codingsDynamicConditions: {
    id: 'zoriRules.codingsDynamicConditions',
    defaultMessage: 'Dynamic conditions',
  },
  codingsDynamicConditionsReadOnly: {
    id: 'zoriRules.codingsDynamicConditionsReadOnly',
    defaultMessage:
      'This coding uses dynamic condition rules. They are visible in results but are not editable in this form yet.',
  },
  codingsClinicOnly: {
    id: 'zoriRules.codingsClinicOnly',
    defaultMessage: 'Clinic only',
  },
  codingsAdditionalCodesHelp: {
    id: 'zoriRules.codingsAdditionalCodesHelp',
    defaultMessage:
      'Aliases are alternate system|code pairs that resolve to this same mapping. Add a code here when a lab or vendor reports the same result under a different system or code (e.g. a Fountain Life biomarker code that should map to this LOINC coding) so results using that coding pick up this display, ranges, and interpretations. An alias cannot be another first-class coding.',
  },
  codingsAliasSystem: {
    id: 'zoriRules.codingsAliasSystem',
    defaultMessage: 'System',
  },
  codingsAliasCode: {
    id: 'zoriRules.codingsAliasCode',
    defaultMessage: 'Code',
  },
  codingsAddAdditionalCode: {
    id: 'zoriRules.codingsAddAdditionalCode',
    defaultMessage: 'Add alias',
  },
  codingsRemoveAdditionalCode: {
    id: 'zoriRules.codingsRemoveAdditionalCode',
    defaultMessage: 'Remove alias',
  },
  codingsAliasCollisionSelf: {
    id: 'zoriRules.codingsAliasCollisionSelf',
    defaultMessage:
      "This is this mapping's own system|code. Use a different coding as the alias.",
  },
  codingsAliasCollisionDuplicate: {
    id: 'zoriRules.codingsAliasCollisionDuplicate',
    defaultMessage: 'This alias is already listed on this mapping.',
  },
  codingsAliasCollisionFirstClass: {
    id: 'zoriRules.codingsAliasCollisionFirstClass',
    defaultMessage:
      'This system|code is already a first-class coding ({display}).',
  },
  codingsAliasCollisionOtherMapping: {
    id: 'zoriRules.codingsAliasCollisionOtherMapping',
    defaultMessage: 'This system|code already maps to {display} ({sourceKey}).',
  },
  codingsAliasCollisionSaveBlocked: {
    id: 'zoriRules.codingsAliasCollisionSaveBlocked',
    defaultMessage:
      'Remove colliding aliases before saving. An alias cannot be another first-class coding.',
  },
  codingsObservationCount: {
    id: 'zoriRules.codingsObservationCount',
    defaultMessage:
      '{count, plural, one {# observation} other {# observations}}',
  },
  codingsObservationCountLoading: {
    id: 'zoriRules.codingsObservationCountLoading',
    defaultMessage: 'Loading observation count…',
  },
  codingsObservationCountError: {
    id: 'zoriRules.codingsObservationCountError',
    defaultMessage: 'Could not load observation count',
  },
  codingsDetailsTitle: {
    id: 'zoriRules.codingsDetailsTitle',
    defaultMessage: 'Coding details',
  },
  codingsDetailsRawJson: {
    id: 'zoriRules.codingsDetailsRawJson',
    defaultMessage: 'Raw JSON',
  },
  codingsEditMapping: {
    id: 'zoriRules.codingsEditMapping',
    defaultMessage: 'Edit mapping',
  },
  codingsEditMappingJson: {
    id: 'zoriRules.codingsEditMappingJson',
    defaultMessage: 'Mapping JSON',
  },
  codingsChangeReason: {
    id: 'zoriRules.codingsChangeReason',
    defaultMessage: 'Change reason',
  },
  codingsSaveChanges: {
    id: 'zoriRules.codingsSaveChanges',
    defaultMessage: 'Save changes',
  },
  codingsDelete: {
    id: 'zoriRules.codingsDelete',
    defaultMessage: 'Delete',
  },
  codingsDeleted: {
    id: 'zoriRules.codingsDeleted',
    defaultMessage: 'Coding deleted',
  },
  codingsDeleteFailed: {
    id: 'zoriRules.codingsDeleteFailed',
    defaultMessage: 'Coding could not be deleted',
  },
  codingsApprove: {
    id: 'zoriRules.codingsApprove',
    defaultMessage: 'Approve',
  },
  codingsAddRange: {
    id: 'zoriRules.codingsAddRange',
    defaultMessage: 'Add range',
  },
  codingsRemoveRange: {
    id: 'zoriRules.codingsRemoveRange',
    defaultMessage: 'Remove range',
  },
  codingsSaved: {
    id: 'zoriRules.codingsSaved',
    defaultMessage: 'Coding saved',
  },
  codingsSaveFailed: {
    id: 'zoriRules.codingsSaveFailed',
    defaultMessage: 'Coding could not be saved',
  },
  codingsInvalidJson: {
    id: 'zoriRules.codingsInvalidJson',
    defaultMessage: 'Mapping JSON is not valid JSON',
  },
  codingsCannotEditReference: {
    id: 'zoriRules.codingsCannotEditReference',
    defaultMessage: 'Reference mappings cannot be edited directly.',
  },
  codingsDisplayRequired: {
    id: 'zoriRules.codingsDisplayRequired',
    defaultMessage: 'Display is required.',
  },
  codingsSystemRequired: {
    id: 'zoriRules.codingsSystemRequired',
    defaultMessage: 'System is required.',
  },
  codingsCodeRequired: {
    id: 'zoriRules.codingsCodeRequired',
    defaultMessage: 'Code is required.',
  },
  codingsAboutRequired: {
    id: 'zoriRules.codingsAboutRequired',
    defaultMessage: 'About text is required.',
  },
  codingsDefaultTextRequired: {
    id: 'zoriRules.codingsDefaultTextRequired',
    defaultMessage: 'Default interpretation text is required.',
  },
  codingsRangeDetailsRequired: {
    id: 'zoriRules.codingsRangeDetailsRequired',
    defaultMessage:
      'Ranged codings require in-range text, attention text, and at least one range.',
  },
  codingsRangeInvalid: {
    id: 'zoriRules.codingsRangeInvalid',
    defaultMessage: 'Reference range bounds must be numbers.',
  },
  codingsShowGuide: {
    id: 'zoriRules.codingsShowGuide',
    defaultMessage: 'How this works',
  },
  codingsGuideDismiss: {
    id: 'zoriRules.codingsGuideDismiss',
    defaultMessage: 'Dismiss',
  },
  codingsGuideTitle: {
    id: 'zoriRules.codingsGuideTitle',
    defaultMessage: 'How codes become results people can see',
  },
  codingsGuideIntro: {
    id: 'zoriRules.codingsGuideIntro',
    defaultMessage:
      'Observations arrive with codes from lab vendors, values extracted from clinical report PDFs, member-uploaded files, and questionnaires. A code mapping is what turns one of those codes into a result PHC and the member app can show: a display name, an explanation, categories, and sometimes reference ranges. This Codings list is where those mappings are drafted, reviewed, and approved.',
  },
  codingsGuideSourcesHeading: {
    id: 'zoriRules.codingsGuideSourcesHeading',
    defaultMessage: '1. Codes arrive from many sources',
  },
  codingsGuideSourcesBody: {
    id: 'zoriRules.codingsGuideSourcesBody',
    defaultMessage:
      'Labs send vendor and LOINC codes. Clinical reports contribute extracted measurements. Members can upload their own files, and questionnaires produce observation codes. Without a mapping, those observations stay in the record but do not appear as filtered, sorted, categorized results.',
  },
  codingsGuideSourcesDiagram: {
    id: 'zoriRules.codingsGuideSourcesDiagram',
    defaultMessage: 'Where observation codes come from',
  },
  codingsGuideMappingHeading: {
    id: 'zoriRules.codingsGuideMappingHeading',
    defaultMessage: '2. Candidates are drafted, then a person approves them',
  },
  codingsGuideMappingBody: {
    id: 'zoriRules.codingsGuideMappingBody',
    defaultMessage:
      'Unmapped codes are drafted as candidates — either by a nightly catalog scan that writes a name and explanation, or by someone creating a mapping here. Drafts show up under Browse needs review. A reviewer can edit the copy, add categories and ranges, approve the mapping, or delete it. Approval is what promotes a candidate into the live catalog; saving without approving leaves it as a draft.',
  },
  codingsGuideMappingDiagram: {
    id: 'zoriRules.codingsGuideMappingDiagram',
    defaultMessage: 'How a mapping is drafted and approved',
  },
  codingsGuideSurfacesHeading: {
    id: 'zoriRules.codingsGuideSurfacesHeading',
    defaultMessage:
      '3. Approved mappings decide what members and clinicians see',
  },
  codingsGuideSurfacesBody: {
    id: 'zoriRules.codingsGuideSurfacesBody',
    defaultMessage:
      'Once a mapping is approved, matching observations can appear as results. Picking or creating a result category in Codings is what defines PHC Lab Results sections and member-app filter pills. Scrolling sections (sub-systems) further group results on the member app. Additional codes are aliases, so another vendor code can share this same display and ranges. Clinic-only mappings stay off the member app. Interpretation text and reference ranges drive in-range, attention, and optimal display.',
  },
  codingsGuideSurfacesBodyHardcoded: {
    id: 'zoriRules.codingsGuideSurfacesBodyHardcoded',
    defaultMessage:
      'Once a mapping is approved, matching observations can appear as results. Result categories (systems) power the filters and sections in PHC and the member app. Scrolling sections (sub-systems) further group results on the member app. Additional codes are aliases, so another vendor code can share this same display and ranges. Clinic-only mappings stay off the member app. Interpretation text and reference ranges drive in-range, attention, and optimal display.',
  },
  codingsGuideSurfacesDiagram: {
    id: 'zoriRules.codingsGuideSurfacesDiagram',
    defaultMessage: 'How an approved mapping reaches PHC and the member app',
  },
  codingsGuideCaveatsHeading: {
    id: 'zoriRules.codingsGuideCaveatsHeading',
    defaultMessage: 'Worth knowing',
  },
  codingsGuideCaveatCategory: {
    id: 'zoriRules.codingsGuideCaveatCategory',
    defaultMessage:
      'A category only surfaces if it is in the result-category registry. Picking or creating a category here publishes it as a PHC Lab Results section and a member-app filter pill. A code saved on a mapping but not in the registry stays hidden until it is remapped.',
  },
  codingsGuideCaveatCategoryHardcoded: {
    id: 'zoriRules.codingsGuideCaveatCategoryHardcoded',
    defaultMessage:
      'A category only surfaces if PHC or the member app already knows that category code. A category outside those lists is saved on the mapping but never shown.',
  },
  codingsGuideCaveatClinicOnly: {
    id: 'zoriRules.codingsGuideCaveatClinicOnly',
    defaultMessage:
      'Clinic-only mappings are visible to clinicians in PHC and never shown to members.',
  },
  codingsGuideCaveatDrafts: {
    id: 'zoriRules.codingsGuideCaveatDrafts',
    defaultMessage:
      'AI-generated drafts are not live until a person approves them. They stay in Browse needs review until then.',
  },
  codingsGuideCaveatObservations: {
    id: 'zoriRules.codingsGuideCaveatObservations',
    defaultMessage:
      'Creating a mapping does not invent observations. It only teaches the catalog how to present codes that already exist in the record.',
  },
  close: {
    id: 'zoriRules.close',
    defaultMessage: 'Close',
  },
  dexConfigSectionsAria: {
    id: 'zoriRules.dexConfigSectionsAria',
    defaultMessage: 'Document extraction configuration sections',
  },
  dexConfigNoPermission: {
    id: 'zoriRules.dexConfigNoPermission',
    defaultMessage:
      'You do not have permission to manage document extraction configuration in this project.',
  },
  dexConfigNoDocumentTypes: {
    id: 'zoriRules.dexConfigNoDocumentTypes',
    defaultMessage: 'No document type config yet',
  },
  dexConfigDocumentTypeColumn: {
    id: 'zoriRules.dexConfigDocumentTypeColumn',
    defaultMessage: 'Document type',
  },
  dexConfigNewDocumentType: {
    id: 'zoriRules.dexConfigNewDocumentType',
    defaultMessage: 'New document type config',
  },
  dexConfigCreateDocumentType: {
    id: 'zoriRules.dexConfigCreateDocumentType',
    defaultMessage: 'New document type',
  },
  dexConfigDocumentTypeIdLabel: {
    id: 'zoriRules.dexConfigDocumentTypeIdLabel',
    defaultMessage: 'Document type ID',
  },
  dexConfigDocumentTypeNameLabel: {
    id: 'zoriRules.dexConfigDocumentTypeNameLabel',
    defaultMessage: 'Display name',
  },
  dexConfigEmbeddingDescriptionLabel: {
    id: 'zoriRules.dexConfigEmbeddingDescriptionLabel',
    defaultMessage: 'Embedding description',
  },
  dexConfigEmbeddingDescriptionHelp: {
    id: 'zoriRules.dexConfigEmbeddingDescriptionHelp',
    defaultMessage:
      'Included when computing multi-modal embeddings for pages of this document type. It helps the embedding service understand the document content, roughly like SEO keywords.',
  },
  dexConfigLlmDescriptionLabel: {
    id: 'zoriRules.dexConfigLlmDescriptionLabel',
    defaultMessage: 'LLM description',
  },
  dexConfigLlmDescriptionHelp: {
    id: 'zoriRules.dexConfigLlmDescriptionHelp',
    defaultMessage:
      'Included in the LLM context when pages of this document type are provided. For example: "This is page 2 of the member report, a bone density scan."',
  },
  dexConfigCreateStructuredResultsLabel: {
    id: 'zoriRules.dexConfigCreateStructuredResultsLabel',
    defaultMessage: 'Create structured results',
  },
  dexConfigCreateStructuredResultsHelp: {
    id: 'zoriRules.dexConfigCreateStructuredResultsHelp',
    defaultMessage:
      'When off, Zori does not generate coded FHIR observations, medications, allergies, or procedures. It still summarizes the document.',
  },
  dexConfigGuidanceIdLabel: {
    id: 'zoriRules.dexConfigGuidanceIdLabel',
    defaultMessage: 'Guidance ID',
  },
  dexConfigGuidanceIdHelp: {
    id: 'zoriRules.dexConfigGuidanceIdHelp',
    defaultMessage:
      'Guidance bundle applied when extracting this document type. Bundles are authored on the Guidance tab.',
  },
  dexConfigGuidanceIdNone: {
    id: 'zoriRules.dexConfigGuidanceIdNone',
    defaultMessage: 'None',
  },
  dexConfigGuidanceIdNoActiveVersion: {
    id: 'zoriRules.dexConfigGuidanceIdNoActiveVersion',
    defaultMessage: '{guidanceId} (no active version)',
  },
  dexConfigGuidanceVersionLabel: {
    id: 'zoriRules.dexConfigGuidanceVersionLabel',
    defaultMessage: 'Guidance version',
  },
  dexConfigFieldInstructionsLabel: {
    id: 'zoriRules.dexConfigFieldInstructionsLabel',
    defaultMessage: 'Field instructions',
  },
  dexConfigObservationRulesTitle: {
    id: 'zoriRules.dexConfigObservationRulesTitle',
    defaultMessage: 'Observation rules',
  },
  dexConfigAddObservationRule: {
    id: 'zoriRules.dexConfigAddObservationRule',
    defaultMessage: 'Add observation rule',
  },
  dexConfigRemoveObservationRule: {
    id: 'zoriRules.dexConfigRemoveObservationRule',
    defaultMessage: 'Remove rule',
  },
  dexConfigObservationRuleTitle: {
    id: 'zoriRules.dexConfigObservationRuleTitle',
    defaultMessage: 'Observation rule {number}',
  },
  dexConfigObservationRuleIdLabel: {
    id: 'zoriRules.dexConfigObservationRuleIdLabel',
    defaultMessage: 'Rule ID',
  },
  dexConfigObservationRuleNameLabel: {
    id: 'zoriRules.dexConfigObservationRuleNameLabel',
    defaultMessage: 'Rule name',
  },
  dexConfigFactTypeLabel: {
    id: 'zoriRules.dexConfigFactTypeLabel',
    defaultMessage: 'Fact type',
  },
  dexConfigCodingSystemLabel: {
    id: 'zoriRules.dexConfigCodingSystemLabel',
    defaultMessage: 'Coding system',
  },
  dexConfigCodingCodeLabel: {
    id: 'zoriRules.dexConfigCodingCodeLabel',
    defaultMessage: 'Coding code',
  },
  dexConfigCodingDisplayLabel: {
    id: 'zoriRules.dexConfigCodingDisplayLabel',
    defaultMessage: 'Coding display',
  },
  dexConfigMatchTermsLabel: {
    id: 'zoriRules.dexConfigMatchTermsLabel',
    defaultMessage: 'Match terms',
  },
  dexConfigExtractionInstructionsLabel: {
    id: 'zoriRules.dexConfigExtractionInstructionsLabel',
    defaultMessage: 'Extraction instructions',
  },
  dexConfigChangeReasonLabel: {
    id: 'zoriRules.dexConfigChangeReasonLabel',
    defaultMessage: 'Change reason',
  },
  dexConfigSave: {
    id: 'zoriRules.dexConfigSave',
    defaultMessage: 'Save config',
  },
  dexConfigDeactivate: {
    id: 'zoriRules.dexConfigDeactivate',
    defaultMessage: 'Deactivate',
  },
  dexConfigEdit: {
    id: 'zoriRules.dexConfigEdit',
    defaultMessage: 'Edit',
  },
  dexConfigCancel: {
    id: 'zoriRules.dexConfigCancel',
    defaultMessage: 'Cancel',
  },
  dexConfigSaved: {
    id: 'zoriRules.dexConfigSaved',
    defaultMessage: 'Document extraction config saved.',
  },
  dexConfigDeactivated: {
    id: 'zoriRules.dexConfigDeactivated',
    defaultMessage: 'Document extraction config deactivated.',
  },
  dexConfigRequiredFields: {
    id: 'zoriRules.dexConfigRequiredFields',
    defaultMessage: 'Document type ID and display name are required.',
  },
  dexConfigGuidanceJsonInvalid: {
    id: 'zoriRules.dexConfigGuidanceJsonInvalid',
    defaultMessage:
      'Guidance must include an ID and version. Observation rules must include rule, coding, fact type, and extraction instruction fields.',
  },
  dexConfigEditDocumentType: {
    id: 'zoriRules.dexConfigEditDocumentType',
    defaultMessage: 'Edit document type config',
  },
  kbSubTabsAria: {
    id: 'zoriRules.kbSubTabsAria',
    defaultMessage: 'Knowledge base management sections',
  },
  statsTab: {
    id: 'zoriRules.statsTab',
    defaultMessage: 'Stats',
  },
  statsSubTabsAria: {
    id: 'zoriRules.statsSubTabsAria',
    defaultMessage: 'Zori statistics',
  },
  zoriPulseTab: {
    id: 'zoriRules.zoriPulseTab',
    defaultMessage: 'Zori Pulse',
  },
  zoriPulseSubTabsAria: {
    id: 'zoriRules.zoriPulseSubTabsAria',
    defaultMessage: 'Zori Pulse tools',
  },
  zoriPulseNoAccess: {
    id: 'zoriRules.zoriPulseNoAccess',
    defaultMessage:
      'You do not have permission to manage Zori Pulse configuration.',
  },
  clinicalReportsTab: {
    id: 'zoriRules.clinicalReportsTab',
    defaultMessage: 'Clinical Reports',
  },
  clinicalReportsSubTabsAria: {
    id: 'zoriRules.clinicalReportsSubTabsAria',
    defaultMessage: 'Clinical report tools',
  },
  clinicalReportsExtractionGuidanceTab: {
    id: 'zoriRules.clinicalReportsExtractionGuidanceTab',
    defaultMessage: 'Extraction Guidance',
  },
  clinicalReportsNoAccess: {
    id: 'zoriRules.clinicalReportsNoAccess',
    defaultMessage:
      'You do not have permission to manage clinical report configuration.',
  },
  clinicalReportsShowGuide: {
    id: 'zoriRules.clinicalReportsShowGuide',
    defaultMessage: 'How this works',
  },
  clinicalReportsGuideDismiss: {
    id: 'zoriRules.clinicalReportsGuideDismiss',
    defaultMessage: 'Dismiss',
  },
  clinicalReportsGuideTitle: {
    id: 'zoriRules.clinicalReportsGuideTitle',
    defaultMessage: 'How clinical reports become structured data',
  },
  clinicalReportsGuideIntro: {
    id: 'zoriRules.clinicalReportsGuideIntro',
    defaultMessage:
      'A clinical report starts life as a PDF or image. Before Zori can read it, the system has to work out what kind of report it is. Once it knows that, it can apply the right instructions for pulling values out of it. The three tools in this section follow that order: Document Types define the kinds of report we recognize, Document Matchers decide which arriving files are each kind, and Extraction Guidance tells the AI what to look for inside them.',
  },
  clinicalReportsGuideMatchingHeading: {
    id: 'zoriRules.clinicalReportsGuideMatchingHeading',
    defaultMessage: '2. Matchers decide which arriving files are which type',
  },
  clinicalReportsGuideMatchingBody: {
    id: 'zoriRules.clinicalReportsGuideMatchingBody',
    defaultMessage:
      'Most reports come in from Elation; members can also upload their own files. Their titles and tags are whatever the sender happened to use, so something has to connect them to one of the types above. As each report arrives, the system checks its own built-in rules first, then the Document Matchers you have enabled here. If nothing matches, the report is not filed as a clinical document at all, and an AI classifier writes up a suggested matcher for someone to review.',
  },
  clinicalReportsGuideMatchingDiagram: {
    id: 'zoriRules.clinicalReportsGuideMatchingDiagram',
    defaultMessage: 'How an incoming report is labelled',
  },
  clinicalReportsGuideMatcherDetailHeading: {
    id: 'zoriRules.clinicalReportsGuideMatcherDetailHeading',
    defaultMessage: 'What a Document Matcher actually compares',
  },
  clinicalReportsGuideMatcherDetailBody: {
    id: 'zoriRules.clinicalReportsGuideMatcherDetailBody',
    defaultMessage:
      "A matcher looks only at the report's descriptive details: its title, its file names, its tags, its report type, and its source. It does not open the PDF and it does not use AI or similarity search to decide — it is a plain pattern check. Every field you fill in has to match, so adding more fields makes a matcher stricter, not more forgiving. The first enabled matcher that fits wins, so ordering matters when two could apply.",
  },
  clinicalReportsGuideMatcherProposalsBody: {
    id: 'zoriRules.clinicalReportsGuideMatcherProposalsBody',
    defaultMessage:
      'Matchers suggested by the AI arrive with the status "proposed" and do nothing until a person enables them. The confidence number on a proposal records how sure the AI was when it wrote the suggestion; it is not a threshold the system checks at match time.',
  },
  clinicalReportsGuideTypesHeading: {
    id: 'zoriRules.clinicalReportsGuideTypesHeading',
    defaultMessage: '1. Document types define the kinds of report',
  },
  clinicalReportsGuideTypesBody: {
    id: 'zoriRules.clinicalReportsGuideTypesBody',
    defaultMessage:
      'A document type is a kind of clinical report the system knows about, such as "dexa" or "grail-multicancer", together with the context the AI needs to read one. Everything else here hangs off it. Registering a type does not make reports start arriving as that type — that is what matchers are for, in the next step. Each type carries:',
  },
  clinicalReportsGuideTypesFieldName: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldName',
    defaultMessage: 'Display name',
  },
  clinicalReportsGuideTypesFieldNameBody: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldNameBody',
    defaultMessage: 'What people see in the UI and in citations.',
  },
  clinicalReportsGuideTypesFieldLlm: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldLlm',
    defaultMessage: 'AI description',
  },
  clinicalReportsGuideTypesFieldLlmBody: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldLlmBody',
    defaultMessage:
      'A sentence handed to the AI along with each page so it knows what it is reading.',
  },
  clinicalReportsGuideTypesFieldEmbedding: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldEmbedding',
    defaultMessage: 'Search description',
  },
  clinicalReportsGuideTypesFieldEmbeddingBody: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldEmbeddingBody',
    defaultMessage:
      'Used when the document is indexed so Zori can find it when answering questions. It has no effect on how reports are labelled.',
  },
  clinicalReportsGuideTypesFieldGuidance: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldGuidance',
    defaultMessage: 'Extraction guidance',
  },
  clinicalReportsGuideTypesFieldGuidanceBody: {
    id: 'zoriRules.clinicalReportsGuideTypesFieldGuidanceBody',
    defaultMessage:
      'The set of instructions applied when this kind of report is read.',
  },
  clinicalReportsGuideExtractionHeading: {
    id: 'zoriRules.clinicalReportsGuideExtractionHeading',
    defaultMessage: '3. Guidance shapes what the AI pulls out',
  },
  clinicalReportsGuideExtractionBody: {
    id: 'zoriRules.clinicalReportsGuideExtractionBody',
    defaultMessage:
      'Extraction guidance is a versioned set of plain-language instructions plus per-result rules that name the preferred medical code for each fact. When a document is read, the system looks up its type, finds the linked guidance, and includes those instructions in what it sends the AI. Afterwards it uses the same rules to tidy up the codes on the results. Guidance is where you say things like which units to expect or which values to ignore.',
  },
  clinicalReportsGuideExtractionDiagram: {
    id: 'zoriRules.clinicalReportsGuideExtractionDiagram',
    defaultMessage: 'How a document is read and reviewed',
  },
  clinicalReportsGuideReviewBody: {
    id: 'zoriRules.clinicalReportsGuideReviewBody',
    defaultMessage:
      'Results are scored before anyone sees them. Very confident results are approved automatically, very poor ones are discarded, and everything in between waits for a clinician. Until a result is approved it stays clinic-only, so it is not visible to the member.',
  },
  clinicalReportsGuideFeedbackHeading: {
    id: 'zoriRules.clinicalReportsGuideFeedbackHeading',
    defaultMessage: '4. Guidance improves from clinician feedback',
  },
  clinicalReportsGuideFeedbackBody: {
    id: 'zoriRules.clinicalReportsGuideFeedbackBody',
    defaultMessage:
      'When clinicians approve or reject extracted results, a nightly job groups that feedback and drafts an improved version of the guidance. Drafts never go live on their own: someone has to approve one, which makes it active and retires the version before it. Because the guidance version is part of how a result is identified, re-running a document after a guidance change produces new results rather than quietly rewriting the old ones.',
  },
  clinicalReportsGuideFeedbackDiagram: {
    id: 'zoriRules.clinicalReportsGuideFeedbackDiagram',
    defaultMessage: 'How guidance is revised',
  },
  clinicalReportsGuideCaveatsHeading: {
    id: 'zoriRules.clinicalReportsGuideCaveatsHeading',
    defaultMessage: 'Worth knowing',
  },
  clinicalReportsGuideCaveatLabs: {
    id: 'zoriRules.clinicalReportsGuideCaveatLabs',
    defaultMessage:
      'Not every lab value comes through this path. Labs that Elation already sends as structured data are loaded directly and never go through extraction.',
  },
  clinicalReportsGuideCaveatUntyped: {
    id: 'zoriRules.clinicalReportsGuideCaveatUntyped',
    defaultMessage:
      'A report that matches nothing is not filed, so it cannot be extracted from later. Enabling a matcher is what makes that class of report visible to the system.',
  },
  clinicalReportsGuideCaveatVisibility: {
    id: 'zoriRules.clinicalReportsGuideCaveatVisibility',
    defaultMessage:
      'Extracted results are not member-visible by default. Files a member uploaded themselves are the exception.',
  },
  kbDropzoneHint: {
    id: 'zoriRules.kbDropzoneHint',
    defaultMessage: 'Drag files or folders here',
  },
  kbChooseFiles: {
    id: 'zoriRules.kbChooseFiles',
    defaultMessage: 'Upload files',
  },
  kbChooseFolder: {
    id: 'zoriRules.kbChooseFolder',
    defaultMessage: 'Upload folder',
  },
  kbEmptyDrop: {
    id: 'zoriRules.kbEmptyDrop',
    defaultMessage:
      'No files found to upload. Empty folders and system files are skipped.',
  },
  kbFilesEmpty: {
    id: 'zoriRules.kbFilesEmpty',
    defaultMessage: 'No files yet',
  },
  kbTableHeaderName: {
    id: 'zoriRules.kbTableHeaderName',
    defaultMessage: 'Name',
  },
  kbTableHeaderContentType: {
    id: 'zoriRules.kbTableHeaderContentType',
    defaultMessage: 'Content Type',
  },
  kbTableHeaderUploaded: {
    id: 'zoriRules.kbTableHeaderUploaded',
    defaultMessage: 'Date uploaded',
  },
  kbTableHeaderSize: {
    id: 'zoriRules.kbTableHeaderSize',
    defaultMessage: 'Size',
  },
  kbTableUnknown: {
    id: 'zoriRules.kbTableUnknown',
    defaultMessage: '—',
  },
  kbOpenFileRowLabel: {
    id: 'zoriRules.kbOpenFileRowLabel',
    defaultMessage: 'Open document in new tab',
  },
  kbOpenFileError: {
    id: 'zoriRules.kbOpenFileError',
    defaultMessage: 'Could not open file',
  },
  kbIngestionNoTask: {
    id: 'zoriRules.kbIngestionNoTask',
    defaultMessage: 'No ingestion task scheduled',
  },
  kbIngestionStatus: {
    id: 'zoriRules.kbIngestionStatus',
    defaultMessage: 'Status: {status}',
  },
  kbIngestionNextRun: {
    id: 'zoriRules.kbIngestionNextRun',
    defaultMessage: 'Next run (UTC window): {when}',
  },
  kbIngestionTaskId: {
    id: 'zoriRules.kbIngestionTaskId',
    defaultMessage: 'Task: {id}',
  },
  kbSyncNow: {
    id: 'zoriRules.kbSyncNow',
    defaultMessage: 'Sync now',
  },
  kbSyncNowSuccess: {
    id: 'zoriRules.kbSyncNowSuccess',
    defaultMessage: 'Knowledge base sync started.',
  },
  kbSyncNowError: {
    id: 'zoriRules.kbSyncNowError',
    defaultMessage: 'Could not start sync. {detail}',
  },
  kbUploadSuccess: {
    id: 'zoriRules.kbUploadSuccess',
    defaultMessage:
      '{count, plural, one {# file uploaded} other {# files uploaded}}',
  },
  kbUploadFileFailed: {
    id: 'zoriRules.kbUploadFileFailed',
    defaultMessage: '{name}: {detail}',
  },
  kbOverwriteTitle: {
    id: 'zoriRules.kbOverwriteTitle',
    defaultMessage: 'Replace existing file?',
  },
  kbOverwriteBody: {
    id: 'zoriRules.kbOverwriteBody',
    defaultMessage:
      'A file named "{name}" is already in this knowledge base. Replace it with your upload?',
  },
  kbOverwriteSkip: {
    id: 'zoriRules.kbOverwriteSkip',
    defaultMessage: 'Skip',
  },
  kbOverwriteReplace: {
    id: 'zoriRules.kbOverwriteReplace',
    defaultMessage: 'Replace',
  },
  kbUploadProgress: {
    id: 'zoriRules.kbUploadProgress',
    defaultMessage: 'Finished {current} of {total}…',
  },
  kbNoUploadPermission: {
    id: 'zoriRules.kbNoUploadPermission',
    defaultMessage:
      'You do not have permission to add or remove files in this project.',
  },
  kbUnavailable: {
    id: 'zoriRules.kbUnavailable',
    defaultMessage:
      'Knowledge base management is not available for this account or project.',
  },
  tasksTab: {
    id: 'zoriAudit.tasksTab',
    defaultMessage: 'Tasks',
  },
  ruleActionsTab: {
    id: 'zoriAudit.ruleActionsTab',
    defaultMessage: 'Rule Actions',
  },
  documentMatchersTab: {
    id: 'zoriAudit.documentMatchersTab',
    defaultMessage: 'Document Matchers',
  },
  emptyTasks: {
    id: 'zoriAudit.emptyTasks',
    defaultMessage: 'No tasks found',
  },
  emptyRuleActions: {
    id: 'zoriAudit.emptyRuleActions',
    defaultMessage: 'No rule actions found',
  },
  ruleActionFilterLabel: {
    id: 'zoriAudit.ruleActionFilterLabel',
    defaultMessage: 'Rule',
  },
  ruleActionFilterAll: {
    id: 'zoriAudit.ruleActionFilterAll',
    defaultMessage: 'All rules',
  },
  emptyDocumentMatchers: {
    id: 'zoriAudit.emptyDocumentMatchers',
    defaultMessage: 'No document matchers found',
  },
  errorLoadingTasks: {
    id: 'zoriAudit.errorLoadingTasks',
    defaultMessage: 'Error loading task audit',
  },
  errorLoadingRuleActions: {
    id: 'zoriAudit.errorLoadingRuleActions',
    defaultMessage: 'Error loading rule action audit',
  },
  errorLoadingDocumentMatchers: {
    id: 'zoriAudit.errorLoadingDocumentMatchers',
    defaultMessage: 'Error loading document matchers',
  },
  selectRowHint: {
    id: 'zoriAudit.selectRowHint',
    defaultMessage: 'Select a row to view details',
  },
  documentMatcherStatusLabel: {
    id: 'zoriAudit.documentMatcherStatusLabel',
    defaultMessage: 'Status',
  },
  documentMatcherStatusFilterLabel: {
    id: 'zoriAudit.documentMatcherStatusFilterLabel',
    defaultMessage: 'Matcher status',
  },
  documentMatcherStatusFilterAll: {
    id: 'zoriAudit.documentMatcherStatusFilterAll',
    defaultMessage: 'All statuses',
  },
  documentMatcherSearchLabel: {
    id: 'zoriAudit.documentMatcherSearchLabel',
    defaultMessage: 'Search matchers',
  },
  documentMatcherNoFilterMatches: {
    id: 'zoriAudit.documentMatcherNoFilterMatches',
    defaultMessage: 'No document matchers match the current filters',
  },
  documentMatcherDocumentTypeLabel: {
    id: 'zoriAudit.documentMatcherDocumentTypeLabel',
    defaultMessage: 'Document type',
  },
  documentMatcherDisplayLabel: {
    id: 'zoriAudit.documentMatcherDisplayLabel',
    defaultMessage: 'Display',
  },
  documentMatcherTitleRegexLabel: {
    id: 'zoriAudit.documentMatcherTitleRegexLabel',
    defaultMessage: 'Title regex',
  },
  documentMatcherFileNameRegexLabel: {
    id: 'zoriAudit.documentMatcherFileNameRegexLabel',
    defaultMessage: 'File name regex',
  },
  documentMatcherTagRegexLabel: {
    id: 'zoriAudit.documentMatcherTagRegexLabel',
    defaultMessage: 'Tag regex',
  },
  documentMatcherRequiredReportTypeLabel: {
    id: 'zoriAudit.documentMatcherRequiredReportTypeLabel',
    defaultMessage: 'Required document type',
  },
  documentMatcherRequiredSourceLabel: {
    id: 'zoriAudit.documentMatcherRequiredSourceLabel',
    defaultMessage: 'Required source',
  },
  documentMatcherReviewNotesLabel: {
    id: 'zoriAudit.documentMatcherReviewNotesLabel',
    defaultMessage: 'Review notes',
  },
  documentMatcherClinicOnlyLabel: {
    id: 'zoriAudit.documentMatcherClinicOnlyLabel',
    defaultMessage: 'Clinic only (ingest but hide from member)',
  },
  documentMatcherFamilyKeyLabel: {
    id: 'zoriAudit.documentMatcherFamilyKeyLabel',
    defaultMessage: 'Family key',
  },
  documentMatcherFamilyKeyRequired: {
    id: 'zoriAudit.documentMatcherFamilyKeyRequired',
    defaultMessage: 'Family key is required',
  },
  documentMatcherFamilyKeyInvalid: {
    id: 'zoriAudit.documentMatcherFamilyKeyInvalid',
    defaultMessage: 'Family key must be lowercase kebab-case, 3-128 characters',
  },
  documentMatcherDocumentTypeRequired: {
    id: 'zoriAudit.documentMatcherDocumentTypeRequired',
    defaultMessage: 'Document type is required',
  },
  documentMatcherDocumentTypeInvalid: {
    id: 'zoriAudit.documentMatcherDocumentTypeInvalid',
    defaultMessage: 'Document type must be a canonical LifeOmic document type',
  },
  documentMatcherInvalidDocumentTypeBadge: {
    id: 'zoriAudit.documentMatcherInvalidDocumentTypeBadge',
    defaultMessage: 'Invalid type',
  },
  documentMatcherInvalidDocumentTypeHint: {
    id: 'zoriAudit.documentMatcherInvalidDocumentTypeHint',
    defaultMessage:
      'Document type "{documentType}" is not lower-kebab-case (for example "other-labs"), so ingestion will not create DocumentReferences for it.',
  },
  documentMatcherDocumentTypeHelp: {
    id: 'zoriAudit.documentMatcherDocumentTypeHelp',
    defaultMessage:
      'Pick a registered type, or enter a new lower-kebab-case code.',
  },
  dexConfigDocumentTypeInvalid: {
    id: 'zoriRules.dexConfigDocumentTypeInvalid',
    defaultMessage:
      'Document type ID must be lower-kebab-case, for example "other-labs"',
  },
  dexConfigInvalidDocumentTypeHint: {
    id: 'zoriRules.dexConfigInvalidDocumentTypeHint',
    defaultMessage:
      'Document type "{documentType}" is not lower-kebab-case (for example "other-labs").',
  },
  dexConfigDocumentTypeIdHelp: {
    id: 'zoriRules.dexConfigDocumentTypeIdHelp',
    defaultMessage:
      'Pick an existing type, or enter a new lower-kebab-case code to register one.',
  },
  dexConfigInvalidDocumentTypeBadge: {
    id: 'zoriRules.dexConfigInvalidDocumentTypeBadge',
    defaultMessage: 'Invalid type',
  },
  documentMatcherDisplayRequired: {
    id: 'zoriAudit.documentMatcherDisplayRequired',
    defaultMessage: 'Display is required',
  },
  documentMatcherMatcherRequired: {
    id: 'zoriAudit.documentMatcherMatcherRequired',
    defaultMessage: 'At least one matcher field is required',
  },
  documentMatcherInvalid: {
    id: 'zoriAudit.documentMatcherInvalid',
    defaultMessage: 'Invalid document matcher',
  },
  documentMatcherSave: {
    id: 'zoriAudit.documentMatcherSave',
    defaultMessage: 'Save changes',
  },
  documentMatcherActivate: {
    id: 'zoriAudit.documentMatcherActivate',
    defaultMessage: 'Activate',
  },
  documentMatcherDelete: {
    id: 'zoriAudit.documentMatcherDelete',
    defaultMessage: 'Delete',
  },
  documentMatcherNew: {
    id: 'zoriAudit.documentMatcherNew',
    defaultMessage: 'New matcher',
  },
  documentMatcherCreate: {
    id: 'zoriAudit.documentMatcherCreate',
    defaultMessage: 'Create matcher',
  },
  documentMatcherCancelCreate: {
    id: 'zoriAudit.documentMatcherCancelCreate',
    defaultMessage: 'Cancel',
  },
  documentMatcherCreated: {
    id: 'zoriAudit.documentMatcherCreated',
    defaultMessage: 'Document matcher created',
  },
  documentMatcherCreateFailed: {
    id: 'zoriAudit.documentMatcherCreateFailed',
    defaultMessage: 'Unable to create document matcher',
  },
  documentMatcherDeleteTitle: {
    id: 'zoriAudit.documentMatcherDeleteTitle',
    defaultMessage: 'Delete document matcher',
  },
  documentMatcherDeleteBody: {
    id: 'zoriAudit.documentMatcherDeleteBody',
    defaultMessage:
      'Delete matcher "{familyKey}" after encoding it in static matchers?',
  },
  documentMatcherDeleteConfirm: {
    id: 'zoriAudit.documentMatcherDeleteConfirm',
    defaultMessage: 'Delete matcher',
  },
  documentMatcherSaved: {
    id: 'zoriAudit.documentMatcherSaved',
    defaultMessage: 'Document matcher saved',
  },
  documentMatcherSaveFailed: {
    id: 'zoriAudit.documentMatcherSaveFailed',
    defaultMessage: 'Unable to save document matcher',
  },
  documentMatcherDeleted: {
    id: 'zoriAudit.documentMatcherDeleted',
    defaultMessage: 'Document matcher deleted',
  },
  documentMatcherDeleteFailed: {
    id: 'zoriAudit.documentMatcherDeleteFailed',
    defaultMessage: 'Unable to delete document matcher',
  },
  createRule: {
    id: 'zoriRules.createRule',
    defaultMessage: 'Create Rule',
  },
  editRule: {
    id: 'zoriRules.editRule',
    defaultMessage: 'Edit Rule',
  },
  saveRule: {
    id: 'zoriRules.saveRule',
    defaultMessage: 'Save Rule',
  },
  cancelRuleEdit: {
    id: 'zoriRules.cancelRuleEdit',
    defaultMessage: 'Cancel',
  },
  activateRule: {
    id: 'zoriRules.activateRule',
    defaultMessage: 'Activate',
  },
  deactivateRule: {
    id: 'zoriRules.deactivateRule',
    defaultMessage: 'Deactivate',
  },
  visibilityHelp: {
    id: 'zoriRules.visibilityHelp',
    defaultMessage:
      'Transparent: the agent can tell the member it executed the rule during a chat. Opaque: the agent will not tell the member that the rule was executed.',
  },
  categoryHelp: {
    id: 'zoriRules.categoryHelp',
    defaultMessage: 'Helps for deduplication of alerts, if applicable.',
  },
  cooldownHelp: {
    id: 'zoriRules.cooldownHelp',
    defaultMessage: 'How often before it can fire a second time.',
  },
  actionParamsHelp: {
    id: 'zoriRules.actionParamsHelp',
    defaultMessage:
      'JSON-ish string that helps guide the agent invocation of the action tool.',
  },
  staticConditionHelp: {
    id: 'zoriRules.staticConditionHelp',
    defaultMessage:
      'JMESPath expression that evaluates to true when the rule should trigger.',
  },
  ruleCreated: {
    id: 'zoriRules.ruleCreated',
    defaultMessage: 'Rule created',
  },
  ruleUpdated: {
    id: 'zoriRules.ruleUpdated',
    defaultMessage: 'Rule updated',
  },
  ruleActivated: {
    id: 'zoriRules.ruleActivated',
    defaultMessage: 'Rule activated',
  },
  ruleDeactivated: {
    id: 'zoriRules.ruleDeactivated',
    defaultMessage: 'Rule deactivated',
  },
  ruleSaveFailed: {
    id: 'zoriRules.ruleSaveFailed',
    defaultMessage: 'Unable to save rule',
  },
  ruleToggleFailed: {
    id: 'zoriRules.ruleToggleFailed',
    defaultMessage: 'Unable to update rule status',
  },
  ruleConditionRequired: {
    id: 'zoriRules.ruleConditionRequired',
    defaultMessage: 'Condition is required',
  },
  rulePriorityInvalid: {
    id: 'zoriRules.rulePriorityInvalid',
    defaultMessage: 'Priority must be between 1 and 10',
  },
  ruleStaticConditionRequired: {
    id: 'zoriRules.ruleStaticConditionRequired',
    defaultMessage: 'Static condition is required for static evaluation mode',
  },
  ruleStaticPreconditionInvalid: {
    id: 'zoriRules.ruleStaticPreconditionInvalid',
    defaultMessage: 'Static precondition must be a valid JMESPath expression',
  },
  ruleActionParamsInvalid: {
    id: 'zoriRules.ruleActionParamsInvalid',
    defaultMessage: 'Action params must be valid JSON',
  },
  ruleScheduleDelayInvalid: {
    id: 'zoriRules.ruleScheduleDelayInvalid',
    defaultMessage: 'Schedule delay must be a number',
  },
  ruleCooldownInvalid: {
    id: 'zoriRules.ruleCooldownInvalid',
    defaultMessage: 'Cooldown must be a number',
  },
  // Form labels
  channelLabel: { id: 'zoriRules.channelLabel', defaultMessage: 'Channel' },
  scopeLabel: { id: 'zoriRules.scopeLabel', defaultMessage: 'Scope' },
  scopeDeferredEvaluationHelp: {
    id: 'zoriRules.scopeDeferredEvaluationHelp',
    defaultMessage:
      'Deferred scopes run in the rule-evaluation async worker after a static rule schedules a task. Use LLM rules here; pair with static rules on the matching stream scope (e.g. appointment -> appointment:deferred).',
  },
  conditionLabel: {
    id: 'zoriRules.conditionLabel',
    defaultMessage: 'Condition',
  },
  evaluationModeLabel: {
    id: 'zoriRules.evaluationModeLabel',
    defaultMessage: 'Evaluation Mode',
  },
  staticConditionLabel: {
    id: 'zoriRules.staticConditionLabel',
    defaultMessage: 'Static Condition',
  },
  scheduleDelayLabel: {
    id: 'zoriRules.scheduleDelayLabel',
    defaultMessage: 'Schedule Delay (hours)',
  },
  actionLabel: { id: 'zoriRules.actionLabel', defaultMessage: 'Action' },
  actionStaticStreamPlaceholderHelp: {
    id: 'zoriRules.actionStaticStreamPlaceholderHelp',
    defaultMessage:
      'This stream scope has no message or notification tools on the live path. Rules still store an action for scheduling and bookkeeping; static rules use create async task so evaluation can run in the deferred worker.',
  },
  actionParamsLabel: {
    id: 'zoriRules.actionParamsLabel',
    defaultMessage: 'Action Params (JSON-ish)',
  },
  visibilityLabel: {
    id: 'zoriRules.visibilityLabel',
    defaultMessage: 'Visibility',
  },
  statusLabel: { id: 'zoriRules.statusLabel', defaultMessage: 'Status' },
  priorityLabel: {
    id: 'zoriRules.priorityLabel',
    defaultMessage: 'Priority (1-10)',
  },
  categoryLabel: { id: 'zoriRules.categoryLabel', defaultMessage: 'Category' },
  categoryNone: {
    id: 'zoriRules.categoryNone',
    defaultMessage: 'None',
  },
  cooldownSecondsLabel: {
    id: 'zoriRules.cooldownSecondsLabel',
    defaultMessage: 'Cooldown Seconds',
  },
  // Table / list
  ruleHeader: { id: 'zoriRules.ruleHeader', defaultMessage: 'Rule' },
  searchRulesFieldLabel: {
    id: 'zoriRules.searchRulesFieldLabel',
    defaultMessage: 'Search rules',
  },
  searchRulesLabel: {
    id: 'zoriRules.searchRulesLabel',
    defaultMessage: 'Search by condition, tool, channel, or ID',
  },
  noRulesMatchSearch: {
    id: 'zoriRules.noRulesMatchSearch',
    defaultMessage: 'No rules match your search',
  },
  searchListLabel: {
    id: 'zoriRules.searchListLabel',
    defaultMessage: 'Search',
  },
  noMatches: {
    id: 'zoriRules.noMatches',
    defaultMessage: 'No matches found',
  },
  whenLabel: { id: 'zoriRules.whenLabel', defaultMessage: 'WHEN:' },
  thenLabel: { id: 'zoriRules.thenLabel', defaultMessage: 'THEN:' },
  idLabel: { id: 'zoriRules.idLabel', defaultMessage: 'ID:' },
  viewDetailsLabel: {
    id: 'zoriRules.viewDetailsLabel',
    defaultMessage: 'View details',
  },
  selectRuleHint: {
    id: 'zoriRules.selectRuleHint',
    defaultMessage: 'Select a rule to view details',
  },
  // Rule details panel
  whenSectionLabel: {
    id: 'zoriRules.whenSectionLabel',
    defaultMessage: 'WHEN',
  },
  staticPreconditionSectionLabel: {
    id: 'zoriRules.staticPreconditionSectionLabel',
    defaultMessage: 'STATIC PRECONDITION',
  },
  ifSectionLabel: {
    id: 'zoriRules.ifSectionLabel',
    defaultMessage: 'IF',
  },
  thenSectionLabel: {
    id: 'zoriRules.thenSectionLabel',
    defaultMessage: 'THEN',
  },
  parametersLabel: {
    id: 'zoriRules.parametersLabel',
    defaultMessage: 'Parameters',
  },
  detailsSectionLabel: {
    id: 'zoriRules.detailsSectionLabel',
    defaultMessage: 'Details',
  },
  recentExecutionsLabel: {
    id: 'zoriRules.recentExecutionsLabel',
    defaultMessage: 'RECENT EXECUTIONS',
  },
  executionsLoading: {
    id: 'zoriRules.executionsLoading',
    defaultMessage: 'Loading executions…',
  },
  executionsEmpty: {
    id: 'zoriRules.executionsEmpty',
    defaultMessage: 'No recent executions recorded',
  },
  executionsLimitationCaption: {
    id: 'zoriRules.executionsLimitationCaption',
    defaultMessage:
      'Showing recent recorded executions; some fires may not be recorded.',
  },
  copyRuleIdLabel: {
    id: 'zoriRules.copyRuleIdLabel',
    defaultMessage: 'Copy rule ID',
  },
  ruleIdCopied: {
    id: 'zoriRules.ruleIdCopied',
    defaultMessage: 'Rule ID copied',
  },
  evaluationModeStaticDescription: {
    id: 'zoriRules.evaluationModeStaticDescription',
    defaultMessage: 'Matched with a fixed expression',
  },
  evaluationModeLlmDescription: {
    id: 'zoriRules.evaluationModeLlmDescription',
    defaultMessage: 'Evaluated by Zori',
  },
  delayHoursDescription: {
    id: 'zoriRules.delayHoursDescription',
    defaultMessage:
      'Evaluated {hours, plural, one {# hour} other {# hours}} after the event',
  },
  summarySectionLabel: {
    id: 'zoriRules.summarySectionLabel',
    defaultMessage: 'SUMMARY',
  },
  flowSectionLabel: {
    id: 'zoriRules.flowSectionLabel',
    defaultMessage: 'FLOW',
  },
  flowDiagramError: {
    id: 'zoriRules.flowDiagramError',
    defaultMessage: 'Could not render the flow diagram.',
  },
  withLabel: { id: 'zoriRules.withLabel', defaultMessage: 'WITH:' },
  evaluationLabel: {
    id: 'zoriRules.evaluationLabel',
    defaultMessage: 'EVALUATION:',
  },
  delayHoursLabel: {
    id: 'zoriRules.delayHoursLabel',
    defaultMessage: 'DELAY (HOURS):',
  },
  metadataLabel: {
    id: 'zoriRules.metadataLabel',
    defaultMessage: 'Metadata',
  },
  accountLabel: {
    id: 'zoriRules.accountLabel',
    defaultMessage: 'Account:',
  },
  toolLabel: { id: 'zoriRules.toolLabel', defaultMessage: 'Tool:' },
  cooldownLabel: {
    id: 'zoriRules.cooldownLabel',
    defaultMessage: 'Cooldown (s):',
  },
  createdLabel: {
    id: 'zoriRules.createdLabel',
    defaultMessage: 'Created:',
  },
  createdByLabel: {
    id: 'zoriRules.createdByLabel',
    defaultMessage: 'Created by:',
  },
  lastEditedLabel: {
    id: 'zoriRules.lastEditedLabel',
    defaultMessage: 'Last edited:',
  },
  editedByLabel: {
    id: 'zoriRules.editedByLabel',
    defaultMessage: 'Edited by:',
  },
  // Option labels for selects
  evaluationModeLlm: {
    id: 'zoriRules.evaluationModeLlm',
    defaultMessage: 'llm',
  },
  evaluationModeStatic: {
    id: 'zoriRules.evaluationModeStatic',
    defaultMessage: 'static',
  },
  evaluationModeRestrictedHelp: {
    id: 'zoriRules.evaluationModeRestrictedHelp',
    defaultMessage:
      'This channel/scope combination only supports static evaluation.',
  },
  visibilityTransparent: {
    id: 'zoriRules.visibilityTransparent',
    defaultMessage: 'transparent',
  },
  visibilityOpaque: {
    id: 'zoriRules.visibilityOpaque',
    defaultMessage: 'opaque',
  },
  statusActive: {
    id: 'zoriRules.statusActive',
    defaultMessage: 'active',
  },
  statusInactive: {
    id: 'zoriRules.statusInactive',
    defaultMessage: 'inactive',
  },
  statusDryRun: {
    id: 'zoriRules.statusDryRun',
    defaultMessage: 'dry run',
  },
  executionStatusWouldHaveRun: {
    id: 'zoriRules.executionStatusWouldHaveRun',
    defaultMessage: 'Would have run',
  },
  dryRunHelperText: {
    id: 'zoriRules.dryRunHelperText',
    defaultMessage:
      'Dry run evaluates this rule normally but records what it would have done instead of performing the action.',
  },
  // Zori analytics: feedback review + usage stats
  feedbackTab: {
    id: 'zoriAnalytics.feedbackTab',
    defaultMessage: 'Feedback',
  },
  agentStatsTab: {
    id: 'zoriAnalytics.agentStatsTab',
    defaultMessage: 'Agent Stats',
  },
  userStatsTab: {
    id: 'zoriAnalytics.userStatsTab',
    defaultMessage: 'User Stats',
  },
  emptyFeedback: {
    id: 'zoriAnalytics.emptyFeedback',
    defaultMessage: 'No feedback found for the selected range',
  },
  emptyAgentStats: {
    id: 'zoriAnalytics.emptyAgentStats',
    defaultMessage: 'No agent activity for the selected range',
  },
  emptyUserStats: {
    id: 'zoriAnalytics.emptyUserStats',
    defaultMessage: 'No clinician activity for the selected range',
  },
  errorLoadingFeedback: {
    id: 'zoriAnalytics.errorLoadingFeedback',
    defaultMessage: 'Error loading Zori feedback',
  },
  errorLoadingAgentStats: {
    id: 'zoriAnalytics.errorLoadingAgentStats',
    defaultMessage: 'Error loading agent stats',
  },
  errorLoadingUserStats: {
    id: 'zoriAnalytics.errorLoadingUserStats',
    defaultMessage: 'Error loading user stats',
  },
  negativeOnlyLabel: {
    id: 'zoriAnalytics.negativeOnlyLabel',
    defaultMessage: 'Negative only',
  },
  rangeFromLabel: {
    id: 'zoriAnalytics.rangeFromLabel',
    defaultMessage: 'From',
  },
  rangeToLabel: {
    id: 'zoriAnalytics.rangeToLabel',
    defaultMessage: 'To',
  },
  openContext: {
    id: 'zoriAnalytics.openContext',
    defaultMessage: 'Open context',
  },
  statColAgent: {
    id: 'zoriAnalytics.statColAgent',
    defaultMessage: 'Agent',
  },
  statColUser: {
    id: 'zoriAnalytics.statColUser',
    defaultMessage: 'Clinician',
  },
  statColGenerations: {
    id: 'zoriAnalytics.statColGenerations',
    defaultMessage: 'Generations',
  },
  statColPositive: {
    id: 'zoriAnalytics.statColPositive',
    defaultMessage: 'Positive',
  },
  statColNegative: {
    id: 'zoriAnalytics.statColNegative',
    defaultMessage: 'Negative',
  },
  statColGenerationsHelp: {
    id: 'zoriAnalytics.statColGenerationsHelp',
    defaultMessage:
      'Times this agent ran in the selected range (one per invocation; for chat agents, one per message).',
  },
  statColPositiveHelp: {
    id: 'zoriAnalytics.statColPositiveHelp',
    defaultMessage:
      'Positive feedback attributed to this agent in the range (chat thumbs-up, accepted suggestions).',
  },
  statColNegativeHelp: {
    id: 'zoriAnalytics.statColNegativeHelp',
    defaultMessage:
      'Negative feedback attributed to this agent in the range (chat thumbs-down, dismissed findings, rejected extractions).',
  },
  statColGenerationsHelpUser: {
    id: 'zoriAnalytics.statColGenerationsHelpUser',
    defaultMessage:
      'Zori runs this clinician triggered in the selected range (invocations and chat messages). Excludes the member-facing agent.',
  },
  statColPositiveHelpUser: {
    id: 'zoriAnalytics.statColPositiveHelpUser',
    defaultMessage:
      'Positive feedback this clinician gave to Zori in the range (chat thumbs-up, accepted suggestions).',
  },
  statColNegativeHelpUser: {
    id: 'zoriAnalytics.statColNegativeHelpUser',
    defaultMessage:
      'Negative feedback this clinician gave to Zori in the range (chat thumbs-down, dismissed findings, rejected extractions).',
  },
});
